
    import { computed, defineComponent, onMounted, ref } from 'vue'
    import { DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-vue-buttons'
    import { useUserStore } from '@/store/user'
    import { AccountApi } from '@/util'

    export default defineComponent({
        name: 'CurrencySelector',

        components: {
            DropDownButton
        },

        setup() {
            const userStore = useUserStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const dataItems = ref<string[]>([])

            const publicData = { dataItems }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const selectedCurrency = computed(() => userStore.currency ?? '')

            const computedData = { selectedCurrency }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function onCurrencySelect(e: DropDownButtonItemClickEvent) {
                const selected = e.item as string
                setAdminCurrency(selected)
            }

            const publicMethods = { onCurrencySelect }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function setAdminCurrency(currency: string) {
                userStore.setAdminCurrency(currency)
            }

            async function loadCurrencies() {
                const api = new AccountApi()
                const response = await api.getSupportedCurrencies()
                dataItems.value = response.data
            }

            /********************************************************************************************************************
             LIFECYCLE HOOKS
             ********************************************************************************************************************/
            onMounted(loadCurrencies)

            return { ...publicData, ...computedData, ...publicMethods }
        }
    })
